import React from 'react';
import { AmenityCard } from '../ui/AmenityCard';
import Support from '../../asset/Amenties/Support.png';
import Hygiene from '../../asset/Amenties/Hygiene.png';
import Pantry from '../../asset/Amenties/Pantry.png';
import Locker from '../../asset/Amenties/Locker.png';
import Parking from '../../asset/Amenties/Parking.png';
import Internet from '../../asset/Amenties/Internet.png';
import Networking from '../../asset/Amenties/Networking.png';
import Backup from '../../asset/Amenties/Backup.png';
import Printing from '../../asset/Amenties/Printing.png';
import ItSupport from '../../asset/Amenties/ItSupport.png';
import { useLocation } from 'react-router-dom';

export const AmenitiesSection= () => {

  const location = useLocation();
  const Meeting = location.pathname !== "/meeting-room"
  const isperungudi = location.pathname === '/perungudi-chennai' || location.pathname === '/affordable-coworking-space-perungudi';

  const topRowAmenities = [
    {
      title: "High-Speed Internet",
      description: "Seamless connectivity to keep you ahead, and your work hassle-free.",
      icon: Internet
    },
    {
      title: "Power Backup",
      description: "Uninterrupted workflow with zero downtime, always.",
      icon: Backup
    },
    {
      title: "Pantry",
      description: "Unlimited tea & coffee to stay refreshed and energized.",
      icon: Pantry
    },

    {
      title: "Reception & Admin Support",
      description: "Efficient assistance for all your operational needs.",
      icon: Support
    },

  ];

  if (Meeting) {
    topRowAmenities.splice(3, 0, {
      title: isperungudi ? 'Fully Stocked Office Supplies' : "Personal Lockers",
      description: isperungudi ? 'Everything you need, within reach.' : "Keep your belongings safe with a dedicated storage facility.",
      icon: Locker
    });
  }

  const middleRowAmenities = [
    {
      title: "Secure Parking Facilities",
      description: "Convenient, spacious and safe parking options.",
      icon: Parking
    },    
    {
      title: "Printing & Scanning Services",
      description: "Efficient and accessible business essentials.",
      icon: Printing
    },
    {
      title: "Professional IT Support",
      description: "On-site tech assistance when you need it.",
      icon: ItSupport
    },
    {
      title: "Community Networking",
      description: "Connect and collaborate with professionals across industries.",
      icon: Networking
    },
  ];

  if (Meeting) {
    middleRowAmenities.splice(1, 0, {
      title: "Housekeeping & Hygiene",
      description: "Clean, sanitized, and comfortable workspaces.",
      icon: Hygiene
    });
  }

  return (
    <section id="amenities" className="py-8 sm:py-12 px-4 sm:px-6 bg-white">
      <div className="max-w-[75rem] mx-auto">
        <h2 className="text-[#966376] font-sans text-base sm:text-lg font-[600] font-semibold uppercase text-center">OUR AMENITIES</h2>
        <h3 className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-5xl font-bold leading-tight mt-3 max-w-4xl mx-auto text-center px-4">
          Workspace Essentials, Elevated
        </h3>

        <div className={`grid grid-cols-1 sm:grid-cols-2 ${Meeting ? 'lg:grid-cols-5' : 'lg:grid-cols-4'} gap-4 sm:gap-6 mt-8 sm:mt-16`}>

          {topRowAmenities.map((amenity, index) => (
            <div key={index} className="col-span-1">
              <AmenityCard
                icon={amenity.icon}
                title={amenity.title}
                description={amenity.description}
              />
            </div>
          ))}
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 ${Meeting ? 'lg:grid-cols-5' : 'lg:grid-cols-4'} gap-4 sm:gap-6 mt-4 sm:mt-6`}>

          {middleRowAmenities.map((amenity, index) => (
            <div key={index} className="col-span-1">
              <AmenityCard
                icon={amenity.icon}
                title={amenity.title}
                description={amenity.description}
              />
            </div>
          ))}
        </div>

        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6 mt-4 sm:mt-6">
          {bottomRowAmenities.map((amenity, index) => (
            <div key={index} className="col-span-1">
              <AmenityCard
                icon={amenity.icon}
                title={amenity.title}
                description={amenity.description}
              />
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
};
